var _g, _path, _g2, _path2, _g3, _path3, _path4, _path5, _path6, _path7, _g4, _path8, _g5, _path9, _g6, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g7, _path21, _path22, _path23, _path24, _path25, _g8, _path26, _g9, _path27, _g10, _path28, _g11, _path29, _g12, _path30, _path31, _g13, _path32, _g14, _path33, _g15, _path34, _g16, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _g17, _path42, _path43, _g18, _path44, _g19, _path45, _g20, _path46, _path47, _g21, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _g22, _path60, _g23, _path61, _g24, _path62, _g25, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _g26, _path87, _g27, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeekReport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 95,
    viewBox: "0 0 136 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.834 83.7463C107.834 82.4294 97.8969 81.3617 85.6384 81.3617C76.9965 81.3617 69.5135 81.8926 65.8474 82.6673C63.7976 81.7978 56.4663 81.1543 47.7349 81.1543C37.4156 81.1543 29.05 82.0529 29.05 83.1616C29.05 84.2701 37.4156 85.1687 47.7349 85.1687C54.5821 85.1687 60.5658 84.773 63.8198 84.1826C64.8379 84.7739 67.8838 85.2886 72.1574 85.6403C68.6517 85.5521 64.9888 85.5049 61.2174 85.5049C35.9689 85.5049 15.5 87.6017 15.5 90.189C15.5 92.7759 35.9689 94.8729 61.2174 94.8729C86.4665 94.8729 106.935 92.7761 106.935 90.189C106.935 88.4491 97.6775 86.9309 83.9344 86.1233C84.4975 86.128 85.0643 86.1309 85.6384 86.1309C97.8966 86.1307 107.834 85.0632 107.834 83.7463Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.834 83.7463C107.834 82.4294 97.8969 81.3617 85.6384 81.3617C76.9965 81.3617 69.5135 81.8926 65.8474 82.6673C63.7976 81.7978 56.4663 81.1543 47.7349 81.1543C37.4156 81.1543 29.05 82.0529 29.05 83.1616C29.05 84.2701 37.4156 85.1687 47.7349 85.1687C54.5821 85.1687 60.5658 84.773 63.8198 84.1826C64.8379 84.7739 67.8838 85.2886 72.1574 85.6403C68.6517 85.5521 64.9888 85.5049 61.2174 85.5049C35.9689 85.5049 15.5 87.6017 15.5 90.189C15.5 92.7759 35.9689 94.8729 61.2174 94.8729C86.4665 94.8729 106.935 92.7761 106.935 90.189C106.935 88.4491 97.6775 86.9309 83.9344 86.1233C84.4975 86.128 85.0643 86.1309 85.6384 86.1309C97.8966 86.1307 107.834 85.0632 107.834 83.7463Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.834 83.7463C107.834 82.4294 97.8969 81.3617 85.6384 81.3617C76.9965 81.3617 69.5135 81.8926 65.8474 82.6673C63.7976 81.7978 56.4663 81.1543 47.7349 81.1543C37.4156 81.1543 29.05 82.0529 29.05 83.1616C29.05 84.2701 37.4156 85.1687 47.7349 85.1687C54.5821 85.1687 60.5658 84.773 63.8198 84.1826C64.8379 84.7739 67.8838 85.2886 72.1574 85.6403C68.6517 85.5521 64.9888 85.5049 61.2174 85.5049C35.9689 85.5049 15.5 87.6017 15.5 90.189C15.5 92.7759 35.9689 94.8729 61.2174 94.8729C86.4665 94.8729 106.935 92.7761 106.935 90.189C106.935 88.4491 97.6775 86.9309 83.9344 86.1233C84.4975 86.128 85.0643 86.1309 85.6384 86.1309C97.8966 86.1307 107.834 85.0632 107.834 83.7463Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_51_7593",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 7,
    width: 20,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5245 10.7347C44.7816 10.2894 47.7991 12.4569 48.2643 15.5756C48.7294 18.6944 46.4657 21.5831 43.2091 22.0284C39.952 22.4738 36.9345 20.3069 36.4693 17.1881C36.0042 14.0694 38.2673 11.1801 41.5245 10.7347ZM34.9754 19.3353C35.2652 20.0011 35.6489 20.6154 36.1081 21.1648L35.4346 22.5179L36.7946 23.4945L38.1546 24.4712L39.3222 23.4736C40.0022 23.7421 40.7252 23.923 41.4743 24.0027L41.9961 25.4139L43.6796 25.1839L45.3625 24.9539L45.451 23.4589C46.1469 23.1814 46.788 22.814 47.3623 22.3743L48.7748 23.0192L49.7948 21.717L50.8154 20.4148L49.773 19.2968C50.0534 18.6457 50.2423 17.9534 50.3261 17.2362L51.8 16.7365L51.5592 15.1252L51.3189 13.5132L49.7582 13.4284C49.4684 12.7621 49.0847 12.1483 48.6255 11.5983L49.299 10.2458L47.939 9.26918L46.579 8.29196L45.4114 9.2901C44.7314 9.02163 44.0084 8.84076 43.2593 8.76107L42.7369 7.34978L41.054 7.57981L39.3711 7.80985L39.2826 9.30479C38.5867 9.5823 37.9456 9.94968 37.3713 10.3894L35.9588 9.7445L34.9382 11.0467L33.9182 12.3489L34.96 13.4669C34.6802 14.1174 34.4913 14.8098 34.4075 15.527L32.9336 16.0272L33.1738 17.6386L33.4141 19.2499L34.9754 19.3353Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_51_7593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.5246 10.7347C44.7817 10.2896 47.7995 12.4565 48.2643 15.5752C48.7292 18.6939 46.466 21.5828 43.2089 22.0285C39.9518 22.4736 36.9347 20.3067 36.4692 17.188C36.0044 14.0693 38.2675 11.1798 41.5246 10.7347ZM34.9754 19.335C35.2652 20.0009 35.6489 20.6149 36.1083 21.1649L35.4347 22.5177L36.7949 23.4941L38.1548 24.4712L39.3219 23.4736C40.0022 23.7414 40.7253 23.9223 41.4742 24.0025L41.9964 25.4138L43.6794 25.1834L45.3625 24.9536L45.4513 23.4585C46.1467 23.1811 46.7879 22.8138 47.3623 22.3741L48.7751 23.0189L49.7949 21.7167L50.8153 20.4146L49.7729 19.2964C50.0532 18.6457 50.2421 17.9533 50.3259 17.2362L51.7998 16.7362L51.5592 15.1247L51.3192 13.5132L49.7584 13.4282C49.4686 12.7623 49.085 12.1484 48.6252 11.5983L49.2992 10.2455L47.9393 9.26909L46.5788 8.29205L45.4116 9.2896C44.7313 9.02122 44.0082 8.84088 43.2593 8.76067L42.7371 7.34939L41.0541 7.57978L39.3711 7.80956L39.2829 9.30468C38.5869 9.58211 37.9457 9.9494 37.3712 10.3891L35.959 9.74434L34.9382 11.0465L33.9182 12.3486L34.96 13.4668C34.6802 14.1175 34.4913 14.8099 34.4075 15.527L32.9336 16.027L33.1738 17.6385L33.4141 19.25L34.9754 19.335Z",
    fill: "url(#paint0_linear_51_7593)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_51_7593",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 0,
    width: 10,
    height: 9
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7494 1.55204C35.2428 1.34744 36.6258 2.34106 36.8395 3.771C37.0525 5.20094 36.0148 6.52518 34.5214 6.72922C33.0286 6.93325 31.6451 5.94021 31.4319 4.51027C31.2187 3.08033 32.2566 1.75608 33.7494 1.55204ZM30.7472 5.49427C30.88 5.80004 31.0558 6.08151 31.2664 6.33358L30.9576 6.95361L31.5811 7.40124L32.2046 7.84944L32.74 7.39163C33.0517 7.51485 33.3828 7.59793 33.7263 7.6341L33.966 8.28125L34.7375 8.17612L35.509 8.07043L35.5497 7.38484C35.8685 7.25768 36.1624 7.08926 36.4257 6.88805L37.0732 7.18364L37.5413 6.58679L38.0088 5.98939L37.5313 5.47675C37.6594 5.17833 37.7461 4.86126 37.7845 4.53232L38.4604 4.30341L38.35 3.56413L38.2396 2.82543L37.5242 2.78643C37.3914 2.48123 37.2155 2.19976 37.0047 1.94768L37.3134 1.32767L36.6901 0.880037L36.0668 0.431834L35.5314 0.889641C35.2197 0.766429 34.888 0.683346 34.5451 0.646608L34.3054 2.38419e-05L33.5339 0.105148L32.7624 0.210846L32.7217 0.895856C32.4024 1.02303 32.1084 1.19145 31.8454 1.39323L31.1978 1.09764L30.7301 1.69448L30.2624 2.29188L30.7401 2.80395C30.6116 3.10294 30.525 3.42002 30.4868 3.74896L29.811 3.97786L29.9212 4.71657L30.0314 5.45528L30.7472 5.49427Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_51_7593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.7499 1.55136C35.2433 1.34717 36.6263 2.34087 36.84 3.7708C37.0531 5.20009 36.0153 6.52503 34.522 6.72921C33.0291 6.93339 31.6456 5.93969 31.4324 4.50976C31.2192 3.08047 32.257 1.75554 33.7499 1.55136ZM30.7476 5.49438C30.8805 5.79969 31.0563 6.081 31.2669 6.33315L30.958 6.95349L31.5816 7.4014L32.2051 7.84866L32.7405 7.39168C33.0522 7.51419 33.3833 7.59715 33.7269 7.6341L33.9665 8.28101L34.738 8.17535L35.5095 8.07034L35.5502 7.38454C35.869 7.25749 36.1629 7.08896 36.4262 6.88737L37.0737 7.18295L37.5418 6.5866L38.0093 5.98896L37.5318 5.47688C37.6598 5.17806 37.7466 4.86109 37.785 4.5318L38.4609 4.30298L38.3505 3.56403L38.2401 2.82508L37.5247 2.78619C37.3919 2.48088 37.216 2.19956 37.0052 1.94741L37.314 1.32708L36.6906 0.87917L36.0673 0.431909L35.5319 0.888893C35.2202 0.765734 34.8885 0.68341 34.5456 0.646462L34.3059 -0.000444412L33.5344 0.105212L32.7629 0.210222L32.7222 0.89602C32.4028 1.02307 32.1089 1.1916 31.8459 1.39319L31.1983 1.09762L30.7306 1.69461L30.2629 2.2916L30.7406 2.80368C30.6121 3.10251 30.5255 3.41948 30.4873 3.74877L29.8115 3.97758L29.9217 4.71654L30.0319 5.45549L30.7476 5.49438Z",
    fill: "url(#paint1_linear_51_7593)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9597 77.3868H62.5654V37.8142H62.9597V77.3868Z",
    fill: "#F3F3F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0091 33.9698H62.7627V32.9384H67.0091V33.9698Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1609 35.8762H62.7627V34.8447H66.1609V35.8762Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.415 81.1064H62.959V79.7308H67.415V81.1064Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_51_7593",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 74,
    y: 24,
    width: 11,
    height: 19
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1202 24.0168C79.1202 24.0168 87.7394 33.8026 82.2716 40.139C76.8045 46.4753 75.2999 40.2622 75.2999 40.2622C75.2999 40.2622 72.028 40.8443 77.6958 32.9186C80.3674 29.1832 79.1202 24.0168 79.1202 24.0168Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_51_7593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.1202 24.0176C79.1202 24.0176 87.7395 33.8024 82.2717 40.1392C76.8046 46.4754 75.2997 40.2626 75.2997 40.2626C75.2997 40.2626 72.0282 40.8443 77.6958 32.919C80.3673 29.1832 79.1202 24.0176 79.1202 24.0176Z",
    fill: "url(#paint2_linear_51_7593)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_51_7593",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 88,
    y: 16,
    width: 12,
    height: 18
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0093 33.6606V24.1806C89.0093 23.7878 88.9396 23.4109 88.8115 23.0599C91.1956 20.7527 94.2137 18.4993 98.0122 16.3815C98.0122 16.3815 102.55 22.7959 97.3339 31.0438C94.7828 31.6683 91.9908 32.3805 89.0093 33.6606Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_51_7593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.0093 33.6606V24.1807C89.0093 23.7879 88.94 23.4107 88.8115 23.0596C91.1961 20.7525 94.2136 18.499 98.0128 16.3813C98.0128 16.3813 102.551 22.7957 97.3339 31.0432C94.7827 31.6678 91.991 32.3804 89.0093 33.6606Z",
    fill: "url(#paint3_linear_51_7593)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_51_7593",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 89,
    y: 27,
    width: 18,
    height: 15
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2862 41.7994C97.7307 40.0756 96.0537 38.8231 94.071 38.8231H89.0088V33.6606C91.9903 32.3805 94.7823 31.6683 97.3335 31.0438C101.004 30.1451 104.174 29.4296 106.685 27.4695C106.685 27.4695 105.499 35.5947 98.2862 41.7994Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_51_7593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.2859 41.7998C97.7305 40.0759 96.0534 38.8233 94.0711 38.8233H89.0088V33.6612C91.9904 32.381 94.7817 31.6684 97.3334 31.044C101.003 30.1455 104.174 29.43 106.684 27.4699C106.684 27.4699 105.499 35.5952 98.2859 41.7998Z",
    fill: "url(#paint4_linear_51_7593)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8263 77.3868H51.4326V37.8142H51.8263V77.3868Z",
    fill: "#F3F3F3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8355 77.3868H79.4414V37.8144H79.8355V77.3868Z",
    fill: "#F3F3F3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3293 33.9698H23.6206V32.9384H30.3293V33.9698Z",
    fill: "#E0E0E0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1368 35.8762H23.6206V34.8447H33.1368V35.8762Z",
    fill: "#E0E0E0"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2038 33.9698H51.3271V32.9384H59.2038V33.9698Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3634 35.8762H51.3271V34.8447H56.3634V35.8762Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7161 33.97H79.8359V32.9385H84.7161V33.97Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5242 35.8766H79.8359V34.8449H85.5242V35.8766Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0859 81.1064H51.6299V79.7308H56.0859V81.1064Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2918 81.1064H79.8359V79.7307H84.2918V81.1064Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_51_7593",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 42,
    width: 113,
    height: 18
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4823 59.9032V57.6012C99.3087 56.9523 100.14 56.2775 100.983 55.5925C101.765 54.9583 102.552 54.3196 103.349 53.6906C103.962 53.9935 104.556 54.3055 105.134 54.6226C104.141 55.389 103.164 56.1791 102.197 56.9636C100.971 57.9595 99.739 58.9599 98.4823 59.9032ZM106.727 53.4289C106.149 53.1011 105.557 52.7772 104.946 52.4607C107.686 50.4074 110.588 48.5688 113.863 47.4785C117.265 46.3453 120.255 45.9237 122.82 45.9237C126.075 45.9237 128.648 46.6025 130.513 47.3683C134.177 48.8712 135.443 50.4458 135.518 50.5357V53.1706C135.468 53.1107 131.081 47.7572 122.479 47.7572C120.127 47.7572 117.459 48.1579 114.479 49.1764C111.704 50.1248 109.155 51.6689 106.727 53.4289ZM23.483 53.1084L23.4238 50.7154C28.7291 45.6354 34.2744 43.1949 39.7994 42.7806V44.7741C34.491 45.194 29.125 47.6826 23.483 53.1084Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_51_7593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.4827 59.9031V57.6011C99.3085 56.9523 100.14 56.2774 100.983 55.5923C101.765 54.9582 102.552 54.3195 103.349 53.6905C103.962 53.9934 104.557 54.3054 105.134 54.6225C104.141 55.3888 103.164 56.179 102.198 56.9635C100.971 57.9594 99.7394 58.9597 98.4827 59.9031ZM106.727 53.4288C106.149 53.101 105.557 52.7771 104.946 52.4606C107.686 50.4072 110.589 48.5689 113.862 47.4784C117.265 46.3454 120.254 45.9237 122.821 45.9237C126.075 45.9237 128.648 46.6026 130.513 47.368C134.177 48.8712 135.443 50.4457 135.518 50.5356V53.1705C135.468 53.1106 131.081 47.7569 122.479 47.7569C120.128 47.7569 117.459 48.1576 114.48 49.1762C111.704 50.1246 109.156 51.6688 106.727 53.4288ZM23.483 53.1083L23.4238 50.7153C28.7291 45.6355 34.2744 43.1948 39.7994 42.7806V44.7741C34.4911 45.1942 29.125 47.6822 23.483 53.1083Z",
    fill: "url(#paint5_linear_51_7593)"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74292 52.536H7.39697V58.1003H8.74292V52.536Z",
    fill: "#E0E0E0"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0847 50.2752H10.7388V58.1003H12.0847V50.2752Z",
    fill: "#E0E0E0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M15.427 49.0957H14.0811V58.1003H15.427V49.0957Z",
    fill: "#E0E0E0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7692 48.604H17.4233V58.1003H18.7692V48.604Z",
    fill: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_51_7593",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 54,
    width: 2,
    height: 5
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74292 54.6091H7.39697V58.1003H8.74292V54.6091Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_51_7593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.74292 54.6091H7.39697V58.1003H8.74292V54.6091Z",
    fill: "url(#paint6_linear_51_7593)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_51_7593",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 53,
    width: 3,
    height: 6
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0847 53.1911H10.7388V58.1003H12.0847V53.1911Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_51_7593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0847 53.1911H10.7388V58.1003H12.0847V53.1911Z",
    fill: "url(#paint7_linear_51_7593)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_51_7593",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 52,
    width: 2,
    height: 7
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M15.427 52.4507H14.0811V58.1003H15.427V52.4507Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_51_7593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.427 52.4507H14.0811V58.1003H15.427V52.4507Z",
    fill: "url(#paint8_linear_51_7593)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_51_7593",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 52,
    width: 2,
    height: 7
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7692 52.1426H17.4233V58.1003H18.7692V52.1426Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_51_7593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7692 52.1426H17.4233V58.1003H18.7692V52.1426Z",
    fill: "url(#paint9_linear_51_7593)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_51_7593",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 20,
    width: 51,
    height: 64
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4703 83.1332H43.3369C41.3831 83.1332 39.7988 81.6162 39.7988 79.7454V64.9565C40.7793 64.7604 41.7491 64.5259 42.7107 64.2591V80.4988H70.6449C71.4176 81.1375 72.424 81.5235 73.5249 81.5235H88.4831C87.8597 82.4894 86.7435 83.1332 85.4703 83.1332ZM39.7988 63.0665V44.774V42.7806V24.1806C39.7988 22.5144 41.0549 21.1292 42.7107 20.8454V62.3414C41.7485 62.6178 40.7775 62.8619 39.7988 63.0665ZM89.0084 38.8231H86.0972V20.8454C87.3621 21.0619 88.3939 21.9227 88.8107 23.0599C88.9387 23.4108 89.0084 23.7878 89.0084 24.1806V33.6606V38.8231Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_51_7593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.4702 83.1332H43.337C41.3831 83.1332 39.7988 81.6162 39.7988 79.7454V64.9566C40.7793 64.7604 41.7491 64.5259 42.7106 64.2591V80.4988H70.6448C71.4174 81.1375 72.4242 81.5235 73.525 81.5235H88.4828C87.8598 82.4894 86.7433 83.1332 85.4702 83.1332ZM39.7988 63.0666V44.7743V42.7807V24.181C39.7988 22.5147 41.0549 21.1293 42.7106 20.8457V62.3414C41.7485 62.6178 40.7775 62.862 39.7988 63.0666ZM89.0083 38.8231H86.0968V20.8457C87.3621 21.0625 88.3938 21.9229 88.8104 23.0601C88.9385 23.4106 89.0083 23.7883 89.0083 24.181V33.6612V38.8231Z",
    fill: "url(#paint10_linear_51_7593)"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M86.097 13.9331H45.0864C43.7744 13.9331 42.7109 14.952 42.7109 16.2083V80.499H86.097V13.9331Z",
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_51_7593",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 69,
    y: 26,
    width: 14,
    height: 2
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0542 27.9443H69.2617V26.3951H82.0542V27.9443Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_51_7593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.0541 27.9447H69.2617V26.3956H82.0541V27.9447Z",
    fill: "url(#paint11_linear_51_7593)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_51_7593",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 69,
    y: 32,
    width: 13,
    height: 3
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0047 34.439H69.2617V32.8898H81.0047V34.439Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_51_7593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.0049 34.4388H69.2617V32.89H81.0049V34.4388Z",
    fill: "url(#paint12_linear_51_7593)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_51_7593",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 69,
    y: 29,
    width: 11,
    height: 3
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4222 31.1919H69.2617V29.6427H79.4222V31.1919Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_51_7593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.422 31.1919H69.2617V29.6426H79.422V31.1919Z",
    fill: "url(#paint13_linear_51_7593)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_51_7593",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 17,
    width: 21,
    height: 20
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5356 17.5436C50.2727 17.5436 45.9914 21.6436 45.9914 26.6828C45.9914 30.2594 48.1896 33.5268 51.5914 35.007C52.8321 35.5473 54.1591 35.8215 55.5356 35.8215C56.9121 35.8215 58.2397 35.5473 59.4798 35.007C62.8822 33.5268 65.0804 30.2594 65.0804 26.6828C65.0804 21.6436 60.7985 17.5436 55.5356 17.5436ZM55.5356 36.3307C54.0823 36.3307 52.681 36.0413 51.3712 35.471C47.78 33.9083 45.459 30.4583 45.459 26.6828C45.459 21.3627 49.9793 17.0344 55.5356 17.0344C61.0919 17.0344 65.6122 21.3627 65.6122 26.6828C65.6122 30.4583 63.2918 33.9083 59.7 35.471C58.3902 36.0413 56.9889 36.3307 55.5356 36.3307Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_51_7593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.5356 17.5436C50.2727 17.5436 45.9914 21.6436 45.9914 26.6828C45.9914 30.2594 48.1896 33.5268 51.5914 35.007C52.8321 35.5473 54.1591 35.8215 55.5356 35.8215C56.9121 35.8215 58.2397 35.5473 59.4798 35.007C62.8822 33.5268 65.0804 30.2594 65.0804 26.6828C65.0804 21.6436 60.7985 17.5436 55.5356 17.5436ZM55.5356 36.3307C54.0823 36.3307 52.681 36.0413 51.3712 35.471C47.78 33.9083 45.459 30.4583 45.459 26.6828C45.459 21.3627 49.9793 17.0344 55.5356 17.0344C61.0919 17.0344 65.6122 21.3627 65.6122 26.6828C65.6122 30.4583 63.2918 33.9083 59.7 35.471C58.3902 36.0413 56.9889 36.3307 55.5356 36.3307Z",
    fill: "url(#paint14_linear_51_7593)"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1586 41.5961H45.459V40.2147H60.1586V41.5961Z",
    fill: "#E0E0E0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1586 45.3127H45.459V43.9308H60.1586V45.3127Z",
    fill: "#E0E0E0"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1586 49.0289H45.459V47.6476H60.1586V49.0289Z",
    fill: "#E0E0E0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M65.613 41.5961H63.1592V40.2147H65.613V41.5961Z",
    fill: "#4E7ED6"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M65.613 45.3127H63.1592V43.9308H65.613V45.3127Z",
    fill: "#4E7ED6"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M65.613 49.0289H63.1592V47.6476H65.613V49.0289Z",
    fill: "#4E7ED6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_51_7593",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 49,
    width: 113,
    height: 17
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1907 65.6292C33.1901 65.6292 33.1895 65.6292 33.1889 65.6292C29.9682 65.6286 27.0861 65.3211 23.4824 64.1642V62.2419C26.8521 63.3237 30.0335 63.7849 33.0868 63.7849C35.3889 63.7849 37.6178 63.5227 39.7988 63.0666C40.7775 62.862 41.7485 62.6178 42.7107 62.3414C47.427 60.9855 51.9662 58.84 56.5999 56.6335C60.6433 54.7085 64.741 52.7574 69.1137 51.2048V53.1316C65.0544 54.6158 61.22 56.4414 57.4357 58.2432C52.5199 60.5842 47.7286 62.8659 42.7107 64.2591C41.7491 64.5259 40.7793 64.7604 39.7988 64.9566C37.6561 65.3844 35.4621 65.6292 33.1907 65.6292ZM124.558 62.5031C124.199 62.5031 123.828 62.4968 123.448 62.4827C117.928 62.2815 113.851 59.9263 109.54 57.2479C108.147 56.382 106.7 55.4828 105.134 54.6226C104.556 54.3055 103.962 53.9935 103.349 53.6906C101.856 52.953 100.25 52.2685 98.4818 51.6898V49.7896C100.892 50.5306 103.012 51.4586 104.945 52.4607C105.556 52.7772 106.149 53.1011 106.726 53.4289C108.073 54.1936 109.338 54.9792 110.562 55.7394C114.812 58.3805 118.484 60.6611 123.458 60.6854C123.518 60.6854 123.576 60.6854 123.636 60.6854C133.581 60.6854 135.506 56.6437 135.517 56.6036V58.9418C135.468 59.1549 132.63 62.5031 124.558 62.5031Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_51_7593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1906 65.6292C33.1901 65.6292 33.1895 65.6292 33.1889 65.6292C29.9682 65.6286 27.086 65.3211 23.4824 64.1641V62.2419C26.852 63.3237 30.0336 63.7849 33.0868 63.7849C35.3889 63.7849 37.6178 63.5226 39.7988 63.0665C40.7776 62.862 41.7485 62.6178 42.7107 62.3414C47.427 60.9855 51.9662 58.84 56.5999 56.6335C60.6433 54.7084 64.741 52.7574 69.1138 51.2048V53.1316C65.0544 54.6157 61.22 56.4414 57.4358 58.2432C52.5199 60.5842 47.7286 62.8659 42.7107 64.2591C41.7491 64.5258 40.7794 64.7604 39.7988 64.9566C37.6562 65.3844 35.4621 65.6292 33.1906 65.6292ZM124.558 62.5031C124.199 62.5031 123.828 62.4968 123.448 62.4826C117.928 62.2815 113.852 59.9263 109.54 57.2479C108.147 56.382 106.699 55.4828 105.134 54.6225C104.556 54.3054 103.962 53.9934 103.348 53.6905C101.856 52.9529 100.249 52.2685 98.4821 51.6897V49.7896C100.893 50.5306 103.011 51.4586 104.945 52.4607C105.556 52.7772 106.149 53.101 106.726 53.4289C108.073 54.1935 109.338 54.9792 110.562 55.7394C114.812 58.3805 118.484 60.6611 123.457 60.6854C123.518 60.6854 123.576 60.6854 123.636 60.6854C133.581 60.6854 135.507 56.6436 135.518 56.6035V58.9417C135.468 59.1548 132.63 62.5031 124.558 62.5031Z",
    fill: "url(#paint15_radial_51_7593)"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0709 81.5236H88.4834C88.8169 81.0064 89.0094 80.3971 89.0094 79.7455V64.7972C92.4559 64.0139 95.5365 62.1148 98.4823 59.9033V77.2998C98.4823 79.6324 96.5077 81.5236 94.0709 81.5236ZM89.0094 62.9694V49.9552C89.594 49.9903 90.1854 50.0367 90.7831 50.0948C93.6796 50.3786 96.2142 50.9472 98.4823 51.6898V57.6012C95.3848 60.0338 92.355 62.1035 89.0094 62.9694ZM98.4823 49.7897C96.2558 49.1057 93.7805 48.5815 90.9733 48.3068C90.311 48.242 89.6556 48.1912 89.0094 48.1539V46.9515C92.8733 45.6835 95.9077 43.8459 98.2867 41.7996C98.4138 42.1938 98.4823 42.6127 98.4823 43.0468V49.7897Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_51_7593",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 89,
    y: 38,
    width: 10,
    height: 9
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0088 46.9512V38.8231H94.071C96.0537 38.8231 97.7307 40.0756 98.2862 41.7994C95.9073 43.846 92.8727 45.6834 89.0088 46.9512Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_51_7593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.0088 46.9512V38.8228H94.0708C96.054 38.8228 97.7311 40.0753 98.2863 41.7992C95.9071 43.8456 92.8728 45.6831 89.0088 46.9512Z",
    fill: "url(#paint16_linear_51_7593)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_51_7593",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 89,
    y: 57,
    width: 10,
    height: 8
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0088 64.7972V62.9694C92.3545 62.1035 95.3844 60.0338 98.4821 57.6012V59.9032C95.5361 62.1148 92.4554 64.0139 89.0088 64.7972Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_51_7593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.0088 64.7974V62.9696C92.3544 62.1037 95.3842 60.0339 98.4817 57.6014V59.9034C95.5359 62.115 92.4552 64.014 89.0088 64.7974Z",
    fill: "url(#paint17_linear_51_7593)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_51_7593",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 38,
    width: 20,
    height: 44
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4827 81.5236H73.5245C72.4236 81.5236 71.4172 81.1375 70.6445 80.4989H86.0968V49.8744C86.1635 49.8744 86.2302 49.8738 86.2969 49.8738C87.1864 49.8738 88.0884 49.9004 89.008 49.9552V62.9694V64.7972V79.7455C89.008 80.3971 88.8156 81.0064 88.4827 81.5236ZM89.008 48.1539C88.0748 48.0997 87.1575 48.0743 86.2556 48.0743C86.2024 48.0743 86.1493 48.0743 86.0968 48.0743V38.8232H89.008V46.9512V48.1539Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_51_7593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.4825 81.5236H73.5247C72.4239 81.5236 71.4171 81.1375 70.6445 80.4989H86.0965V49.8745C86.1634 49.8745 86.2303 49.8739 86.2966 49.8739C87.1866 49.8739 88.0881 49.9005 89.008 49.9553V62.9694V64.7973V79.7455C89.008 80.3971 88.8158 81.0064 88.4825 81.5236ZM89.008 48.1539C88.0745 48.0999 87.1574 48.0741 86.2553 48.0741C86.2026 48.0741 86.1492 48.0742 86.0965 48.0744V38.8232H89.008V46.9515V48.1539Z",
    fill: "url(#paint18_linear_51_7593)"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0973 80.499H70.6449C69.7078 79.7247 69.1143 78.5785 69.1143 77.3V53.1319C74.2873 51.2402 79.8275 49.9029 86.0973 49.8747V80.499ZM69.1143 51.2051V43.047C69.1143 40.7144 71.0892 38.8233 73.5251 38.8233H86.0973V48.0746C79.8164 48.0957 74.2741 49.3728 69.1143 51.2051Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_51_7593",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 69,
    y: 48,
    width: 30,
    height: 6
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1143 53.1316V51.2048C74.2745 49.3725 79.8166 48.0952 86.0977 48.0742C86.1502 48.0742 86.2033 48.0742 86.2565 48.0742C87.1584 48.0742 88.0757 48.0997 89.0089 48.1539C89.6559 48.1912 90.3111 48.2421 90.9734 48.3065C93.7807 48.5812 96.2558 49.1057 98.4823 49.7896V51.6898C96.2139 50.9471 93.6798 50.3785 90.7827 50.0948C90.1854 50.0366 89.5939 49.9902 89.0089 49.9552C88.0893 49.9004 87.1873 49.8738 86.2978 49.8738C86.2311 49.8738 86.1644 49.8744 86.0977 49.8744C79.8278 49.9026 74.2874 51.2399 69.1143 53.1316Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_51_7593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.1143 53.1317V51.205C74.2743 49.3726 79.8164 48.0956 86.097 48.0744C86.1501 48.0742 86.2033 48.0741 86.2564 48.0741C87.1583 48.0741 88.0755 48.1 89.009 48.1539C89.6551 48.1912 90.3105 48.242 90.9729 48.3068C93.7801 48.5815 96.2554 49.1057 98.4819 49.7898V51.6899C96.2138 50.9472 93.6792 50.3787 90.7826 50.0949C90.185 50.0367 89.5935 49.9904 89.009 49.9553C88.0886 49.9005 87.1868 49.874 86.2972 49.874C86.231 49.874 86.164 49.8745 86.097 49.8745C79.8271 49.9028 74.2874 51.2401 69.1143 53.1317Z",
    fill: "url(#paint19_radial_51_7593)"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M91.736 49.9739C90.2835 50.4707 88.7192 50.022 87.776 48.9606C87.5511 48.7076 87.3617 48.4197 87.2176 48.1014C87.1852 48.0312 87.1557 47.9593 87.1286 47.8862C86.8547 47.1516 86.8554 46.3868 87.0818 45.6956C87.4078 44.698 88.2016 43.8536 89.3085 43.4747C89.6738 43.3495 90.0465 43.2844 90.414 43.2737C91.9345 43.2297 93.3765 44.1171 93.916 45.562C94.5861 47.3567 93.6097 49.3318 91.736 49.9739ZM95.0486 45.1741C94.3288 43.2472 92.4061 42.0637 90.3785 42.122C89.8881 42.1362 89.3908 42.2231 88.9041 42.39C87.4266 42.8957 86.368 44.0218 85.9326 45.3522C85.6322 46.2742 85.63 47.2943 85.9959 48.2743C86.0322 48.3717 86.0714 48.4676 86.1144 48.5612C86.3068 48.9856 86.5589 49.3697 86.8599 49.7072C88.1178 51.1229 90.205 51.7215 92.1412 51.0585C94.6412 50.2022 95.9428 47.5679 95.0486 45.1741Z",
    fill: "#E0E0E0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0813 45.6956L85.9326 45.3521C86.3672 44.0217 87.4266 42.8956 88.9032 42.3899C89.3904 42.223 89.8869 42.1361 90.3777 42.1219L90.4137 43.2736C90.0462 43.2843 89.6736 43.3494 89.3082 43.4746C88.2005 43.8536 87.4071 44.6979 87.0813 45.6956Z",
    fill: "#537FFD"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2175 48.1016L86.114 48.5614C86.0719 48.4678 86.032 48.3719 85.9962 48.2744C85.6303 47.2945 85.6317 46.2744 85.9331 45.3524L87.0814 45.6958C86.8557 46.387 86.8543 47.1518 87.1291 47.8864C87.1558 47.9596 87.1859 48.0314 87.2175 48.1016Z",
    fill: "#4BA6F3"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8603 49.707C86.5595 49.3696 86.3066 48.9855 86.1143 48.5611L87.2175 48.1012C87.3619 48.4195 87.5521 48.7074 87.7761 48.9605L86.8603 49.707Z",
    fill: "#46BBED"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4802 71.8837H87.8887V80.019H90.4802V71.8837Z",
    fill: "#46BBED"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6278 74.1654H84.0361V80.0192H86.6278V74.1654Z",
    fill: "#46BBED"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2173 68.1132H91.626V80.019H94.2173V68.1132Z",
    fill: "#46BBED"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0375 71.0454L72.8125 70.8798L77.0349 65.619L82.2467 65.8897L86.177 59.8975L90.4105 59.4787L92.9544 54.661L93.2075 54.7836L90.5934 59.7341L86.343 60.1541L82.398 66.17L77.1692 65.8982L73.0375 71.0454Z",
    fill: "#46BBED"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0243 44.8853H73.6551C73.19 44.8853 72.8125 44.5241 72.8125 44.0787C72.8125 43.6332 73.19 43.2721 73.6551 43.2721H81.0243C81.49 43.2721 81.8669 43.6332 81.8669 44.0787C81.8669 44.5241 81.49 44.8853 81.0243 44.8853Z",
    fill: "#4E7ED6"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0243 47.6993H73.6551C73.19 47.6993 72.8125 47.3382 72.8125 46.8928C72.8125 46.4473 73.19 46.0861 73.6551 46.0861H81.0243C81.49 46.0861 81.8669 46.4473 81.8669 46.8928C81.8669 47.3382 81.49 47.6993 81.0243 47.6993Z",
    fill: "#E0E0E0"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0243 50.5137H73.6551C73.19 50.5137 72.8125 50.1525 72.8125 49.7071C72.8125 49.2618 73.19 48.9004 73.6551 48.9004H81.0243C81.49 48.9004 81.8669 49.2618 81.8669 49.7071C81.8669 50.1525 81.49 50.5137 81.0243 50.5137Z",
    fill: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_51_7593",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 65,
    width: 5,
    height: 3
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4794 67.4321H16.4459L15.538 65.6292H12.5713L13.4794 67.4321Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_51_7593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4794 67.4321H16.4459L15.538 65.6292H12.5713L13.4794 67.4321Z",
    fill: "url(#paint20_linear_51_7593)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_51_7593",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 65,
    width: 2,
    height: 3
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0911 67.4321H12.7981L11.89 65.6292H11.1831L12.0911 67.4321Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_51_7593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0911 67.4321H12.7981L11.89 65.6292H11.1831L12.0911 67.4321Z",
    fill: "url(#paint21_linear_51_7593)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_51_7593",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 8,
    width: 7,
    height: 2
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M63.835 9.44495H69.7082V8.42647H63.835V9.44495Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_51_7593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.835 9.44519H69.7078V8.42636H63.835V9.44519Z",
    fill: "url(#paint22_linear_51_7593)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_51_7593",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 63,
    y: 7,
    width: 7,
    height: 2
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M63.835 8.14282H69.7082V7.95122H63.835V8.14282Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_51_7593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.835 8.14294H69.7077V7.95113H63.835V8.14294Z",
    fill: "url(#paint23_linear_51_7593)"
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2611 64.6886C22.2611 64.6886 21.4084 65.0939 20.6007 65.1702C20.6007 65.1702 19.8374 64.0986 19.3907 63.2965C18.3253 61.3828 18.0108 60.4875 18.1017 59.7528C18.2651 58.4319 20.9776 53.1485 20.9776 53.1485L23.9886 54.2614L21.6835 58.1838C21.4683 58.5857 21.1907 59.239 20.9039 59.7703C20.528 60.4666 20.9805 62.0605 21.2484 62.7263C21.2484 62.7263 21.7397 64.0155 22.2611 64.6886Z",
    fill: "#EEA886"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8516 86.452C12.8516 86.452 12.7628 86.9302 13.1084 87.5683C13.454 88.207 15.002 89.8342 14.8954 90.5022C14.7888 91.1708 12.9999 91.0917 11.8764 89.9155C10.7531 88.7388 9.08462 87.5174 9.14619 87.2348C9.20769 86.9522 10.8925 85.4844 11.4781 85.2894C12.0639 85.0944 12.8516 86.452 12.8516 86.452Z",
    fill: "#353A3D"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4695 85.823L12.8369 86.4752L11.4141 85.3143L12.0682 84.588L13.4695 85.823Z",
    fill: "#EEA886"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5156 84.5881C12.2097 83.8342 17.811 78.3467 17.811 78.3467C20.6678 75.1935 21.7856 75.1104 21.7856 75.1104C21.7856 75.1104 22.5075 75.1251 23.4874 75.2528C23.6282 75.2715 24.0869 75.267 24.234 75.2901C26.053 75.5722 26.1037 75.3738 25.4389 76.8003C24.3453 79.1464 13.379 85.9158 13.379 85.9158L11.5156 84.5881Z",
    fill: "#248C9E"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1044 87.4479C37.1044 87.4479 38.0028 87.8232 38.7943 87.9261C39.5859 88.0295 41.4925 87.7288 42.0343 88.2268C42.5756 88.7247 41.4087 90.1659 39.652 90.3807C37.8959 90.5955 35.6464 90.9516 35.4274 90.7272C35.2084 90.5028 35.026 88.4868 35.2072 87.8792C35.389 87.2722 37.1044 87.4479 37.1044 87.4479Z",
    fill: "#353A3D"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7271 86.5566L37.1043 87.4479L35.2072 87.8792L34.9209 86.9251L36.7271 86.5566Z",
    fill: "#EEA886"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M33.88 75.2883C33.88 75.2883 33.1085 72.4691 34.9212 79.1107C34.9212 79.1107 36.8326 86.1977 37.0427 86.6007C37.0923 86.6962 34.6468 87.1246 34.6019 87.1077C34.1763 86.9449 30.3692 77.8651 29.423 76.1881C28.5898 74.7118 33.88 75.2883 33.88 75.2883Z",
    fill: "#248C9E"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8815 75.2883L30.0755 77.3846C30.0755 77.3846 28.5781 75.6235 27.5862 74.9046C27.4842 74.8317 27.3823 74.7576 27.2789 74.6808C27.1325 74.5745 26.9861 74.466 26.8397 74.3563C26.7334 74.2766 26.6258 74.1953 26.5209 74.1144C25.796 73.5605 25.1184 73.001 24.7451 72.5873C23.667 71.3953 26.0271 63.8596 29.0074 67.2208C29.0074 67.2208 33.0025 70.8126 33.8815 75.2883Z",
    fill: "#248C9E"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M28.769 66.3272C28.769 66.3272 26.8935 74.5785 25.045 77.3853C25.045 77.3853 21.9057 76.3719 20.4638 75.8304C20.4638 75.8304 20.3239 69.8676 20.463 68.3094C20.5928 66.8557 28.769 66.3272 28.769 66.3272Z",
    fill: "#248C9E"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0859 69.2209C20.0859 69.2209 20.8767 61.8062 20.2218 58.3562C19.7862 56.0632 20.4164 52.3414 21.8523 50.3333C22.0264 50.0891 22.2072 49.8727 22.3935 49.6879C22.3935 49.6879 25.2925 50.4232 25.5826 50.617C25.624 50.6447 25.9373 50.9104 26.3344 51.3755H26.3349C27.1597 52.3443 28.3778 54.0981 28.4963 55.8004C28.5823 57.0388 28.6533 58.1759 28.7341 59.3493C28.7583 59.7065 28.7841 60.0665 28.8109 60.4344C28.8757 61.3173 28.9499 62.2419 29.0426 63.261C29.0941 63.8279 29.4931 65.6263 29.7557 67.2846L20.0859 69.2209Z",
    fill: "#2AA3B8"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2785 74.6808C27.1322 74.5745 26.9857 74.466 26.8393 74.3564C26.733 74.2767 26.6254 74.1953 26.5205 74.1145C26.6727 73.6499 27.4997 71.5298 27.8242 70.0168C27.8242 70.0168 28.0638 72.3742 27.2785 74.6808Z",
    fill: "#196370"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8115 60.4346C28.8115 60.4346 27.1243 62.8898 26.8252 56.8264L28.7348 59.3494C28.759 59.7066 28.7848 60.0666 28.8115 60.4346Z",
    fill: "#1D6F7D"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3935 49.6879C22.3935 49.6879 22.6958 48.0844 22.3437 47.1518C21.9917 46.2204 25.2283 48.7231 25.2283 48.7231C25.2283 48.7231 25.2283 48.8525 25.2337 49.0464C25.238 49.1979 25.2467 49.3889 25.2607 49.589C25.29 49.971 25.3431 50.3865 25.4417 50.625C25.6583 51.15 22.3935 49.6879 22.3935 49.6879Z",
    fill: "#EEA886"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0739 44.0681C27.0739 44.0681 27.7561 45.2986 27.4125 45.4873C27.1285 45.6428 27.7345 46.85 27.8134 47.0473C27.8924 47.2445 27.2987 47.3836 27.172 47.509C27.0453 47.6345 26.6612 49.1894 26.1728 49.2329C25.6843 49.277 23.4899 48.5303 22.8951 47.9307C22.3004 47.3304 21.8276 44.6339 22.2353 43.5007C22.6429 42.3669 25.8699 41.9187 27.0739 44.0681Z",
    fill: "#EEA886"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2104 44.3349C27.2104 44.3349 27.9246 43.0152 26.6508 42.0249C25.377 41.0347 23.0038 42.7433 22.7372 42.8077C22.4706 42.8716 20.8897 43.3543 21.683 45.606C22.4029 47.6486 22.4953 47.8787 22.4953 47.8787C22.4953 47.8787 22.9325 46.5211 23.2108 46.3306C23.6452 46.0327 24.5929 46.1113 24.5929 46.1113C24.5929 46.1113 24.1491 44.96 24.8561 44.8018C25.5633 44.6435 26.4979 44.0766 27.2104 44.3349Z",
    fill: "#3B3B40"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8454 45.4484C23.7843 45.2907 23.5877 44.6125 22.9782 45.0064C22.3687 45.3998 23.3446 46.6822 23.4503 46.6992C23.556 46.7167 24.3603 46.7778 23.8454 45.4484Z",
    fill: "#EEA886"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M25.261 49.589C24.258 49.3307 23.3979 48.2885 23.3979 48.2885C23.672 48.5445 25.2339 49.0464 25.2339 49.0464C25.2383 49.1979 25.247 49.3889 25.261 49.589Z",
    fill: "#A77860"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4602 58.3122L34.8269 66.3645L29.4292 65.3607L30.8517 57.2694L36.4602 58.3122Z",
    fill: "#616161"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M36.055 58.7044L34.6047 65.8558L29.811 64.964L31.0743 57.7781L36.055 58.7044Z",
    fill: "#E0CEC7"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5354 58.6061L34.6369 58.1042L32.6991 57.7442L32.522 58.2319L34.5354 58.6061Z",
    fill: "#616161"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8289 63.9648C35.8289 63.9648 35.5916 64.0603 35.4665 64.0535C35.4665 64.0535 35.2398 64.0241 35.0775 64.0128C35.0261 64.0094 34.9813 64.0071 34.9518 64.0094C34.8302 64.0162 34.5645 64.0659 34.267 64.0037C33.9695 63.9421 32.7583 63.3583 32.7583 63.3583L32.9017 62.6416L32.9366 61.9527C32.9366 61.9527 34.7021 61.3779 34.986 61.405C35.0137 61.4078 35.0415 61.4118 35.0669 61.4169C35.3048 61.4621 35.4624 61.5921 35.5845 61.6294C35.6294 61.6435 36.065 61.8114 36.1075 61.9391C36.1671 62.1166 36.1329 62.263 36.0491 62.3624C36.0491 62.3624 36.1494 62.7151 36.0444 62.9395C36.0444 62.9395 36.1477 63.2622 35.934 63.5058C35.934 63.5058 36.0007 63.8444 35.8289 63.9648Z",
    fill: "#EEA886"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3435 61.7944C33.3435 61.7944 33.1753 62.6913 32.7585 63.3583C32.7585 63.3583 31.4047 63.3068 30.4657 63.1723C28.226 62.8524 27.2872 62.5608 26.7249 62.0532C25.7145 61.141 22.8979 55.9073 22.8979 55.9073L25.6247 54.2547L27.5423 58.3637C27.7513 58.7689 28.134 59.3714 28.409 59.9083C28.7694 60.6126 30.376 61.2139 31.0938 61.4044C31.0938 61.4044 32.4681 61.7944 33.3435 61.7944Z",
    fill: "#EEA886"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9843 56.4883L23.8847 58.0319C23.8847 58.0319 23.2701 56.893 23.0902 56.5228C22.5739 55.4614 21.7756 53.8568 22.7796 53.1791C24.9463 51.7164 25.8778 54.1439 26.41 55.4749C26.5743 55.8853 26.9843 56.4883 26.9843 56.4883Z",
    fill: "#2AA3B8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_51_7593",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 21,
    width: 3,
    height: 11
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8492 31.9691H54.2236V21.396H56.8492V31.9691Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_51_7593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.8492 31.9691H54.2236V21.396H56.8492V31.9691Z",
    fill: "url(#paint24_linear_51_7593)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_51_7593",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 25,
    width: 12,
    height: 3
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0146 27.9398V25.4253H61.0575V27.9398H50.0146Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_51_7593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0146 27.9398V25.4253H61.0575V27.9398H50.0146Z",
    fill: "url(#paint25_linear_51_7593)"
  }))), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6642 37.7708C17.8047 39.5099 15.9306 40.4775 14.0395 40.3317C13.5888 40.2967 13.137 40.1989 12.6978 40.0327C12.6008 39.996 12.5043 39.9558 12.4087 39.9129C11.4488 39.4777 10.714 38.7718 10.2571 37.9353C9.59736 36.728 9.5162 35.2495 10.1717 33.923C10.388 33.4855 10.6687 33.0967 10.9974 32.7621C12.3556 31.3807 14.539 30.9257 16.4269 31.7809C18.7722 32.8434 19.7737 35.5253 18.6642 37.7708ZM17.0977 30.4244C14.5796 29.2833 11.6679 29.8897 9.85585 31.7323C9.41715 32.1782 9.04292 32.6971 8.75427 33.2809C7.88025 35.05 7.98833 37.0225 8.86802 38.6322C9.47766 39.7478 10.4577 40.69 11.7383 41.2699C11.8656 41.3276 11.9944 41.3813 12.1235 41.4299C12.7095 41.6514 13.3118 41.782 13.9131 41.8283C16.4355 42.0233 18.9353 40.733 20.0818 38.4129C21.5617 35.4179 20.2256 31.8414 17.0977 30.4244Z",
    fill: "#E0E0E0"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2571 37.9352L8.86802 38.6321C7.98833 37.0224 7.88025 35.0499 8.75427 33.2808C9.04292 32.697 9.41715 32.1781 9.85585 31.7322L10.9974 32.762C10.6687 33.0966 10.388 33.4854 10.1717 33.9229C9.5162 35.2494 9.59736 36.7279 10.2571 37.9352Z",
    fill: "#2D5BAD"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6974 40.0326L12.1232 41.4298C11.994 41.3812 11.8652 41.3275 11.738 41.2699C10.4574 40.69 9.47731 39.7478 8.86768 38.6321L10.2567 37.9352C10.7137 38.7717 11.4484 39.4776 12.4084 39.9128C12.504 39.9558 12.6005 39.9959 12.6974 40.0326Z",
    fill: "#5D96FF"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9131 41.8282C13.3118 41.7819 12.7095 41.6513 12.1235 41.4298L12.6978 40.0326C13.137 40.1988 13.5888 40.2966 14.0396 40.3316L13.9131 41.8282Z",
    fill: "#5D96FF"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4928 45.7823H0.792969V45.5597H12.2603V40.8137H12.4928V45.7823Z",
    fill: "#5D96FF"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9515 44.5785H0.792969V43.2424H6.9515V44.5785Z",
    fill: "#E0E0E0"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7714 61.8108C63.7714 61.8108 64.1137 62.5585 64.4419 62.4653C64.7695 62.3714 65.2565 62.3986 65.4094 62.415C65.6136 62.4364 66.2783 62.2872 66.2393 62.5252C66.2003 62.7631 65.1538 62.8191 64.9348 62.8711C64.7164 62.9225 65.5026 63.4555 65.5575 63.6601C65.6124 63.8647 64.5145 65.0516 64.024 64.6266C63.5329 64.2021 63.3298 63.438 63.2265 63.3792C63.1232 63.321 62.6729 62.7122 62.6729 62.7122L63.7714 61.8108Z",
    fill: "#EEA886"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4692 63.5352C65.4692 63.5352 66.8729 64.9312 66.8776 65.0996C66.8824 65.268 66.792 65.337 66.6545 65.2115C66.517 65.0861 65.2538 63.9008 65.2538 63.9008C65.2538 63.9008 66.599 65.8219 66.6356 65.9576C66.6575 66.0373 66.4898 66.1797 66.4095 66.1192C66.3287 66.0588 64.8736 64.2292 64.8736 64.2292C64.8736 64.2292 66.125 66.0254 66.1185 66.1492C66.1132 66.2571 65.9255 66.3543 65.8222 66.2272C65.7189 66.1006 64.451 64.4983 64.451 64.4983C64.451 64.4983 65.2697 65.8615 65.1971 65.9661C65.1529 66.0299 65.0141 66.1594 64.8152 65.8005C64.6163 65.4421 64.0479 64.6458 64.0479 64.6458L65.4692 63.5352Z",
    fill: "#EEA886"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3795 88.0414C46.3795 88.0414 45.8417 88.4093 45.5437 88.6665C45.2456 88.9242 44.84 89.2045 44.5915 89.8619C44.3407 90.5271 44.7367 91.0047 45.4091 91.0443C46.082 91.0838 47.1126 90.5972 47.213 90.0077C47.3127 89.4238 48.1025 89.4922 48.2058 89.0768C48.3085 88.6614 48.171 88.1505 48.171 88.1505L46.3795 88.0414Z",
    fill: "#353A3D"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4686 87.5588L46.3789 88.0414C46.3789 88.0414 46.6563 88.5326 48.1704 88.1505L48.0925 87.6746L46.4686 87.5588Z",
    fill: "#81807E"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1704 88.1504C48.1704 88.1504 47.8292 88.1933 47.5866 88.2301C47.3434 88.2663 46.8623 87.969 46.3789 88.0413L46.5277 88.6285C46.5277 88.6285 48.1367 88.3403 48.1704 88.1504Z",
    fill: "#353A3D"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0517 87.9453C56.0517 87.9453 56.5894 88.3126 56.8875 88.5704C57.1856 88.8281 57.5911 89.1079 57.8396 89.7652C58.0911 90.4304 57.695 90.9086 57.0221 90.9476C56.3498 90.9871 55.3186 90.5011 55.2182 89.911C55.119 89.3272 54.3287 89.3961 54.226 88.9807C54.1227 88.5653 54.2602 88.0543 54.2602 88.0543L56.0517 87.9453Z",
    fill: "#353A3D"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9615 87.4621L56.0513 87.9454C56.0513 87.9454 55.7744 88.436 54.2598 88.0544L54.3383 87.5786L55.9615 87.4621Z",
    fill: "#81807E"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6865 76.4764C56.6865 77.5379 56.5277 87.5503 56.5277 87.5503C56.4167 87.9041 54.346 88.02 53.9765 87.8431C53.607 87.6661 53.6719 77.7374 53.6034 76.6675C53.5356 75.5976 52.6372 67.725 52.3131 67.76C51.9896 67.7956 50.158 75.2115 49.8995 76.0249C49.6409 76.8387 48.6227 87.7865 48.6227 87.7865C47.3589 88.2076 46.0674 87.8368 46.0674 87.8368C46.0674 87.8368 46.5508 76.7494 46.5508 75.4331C46.5514 74.9448 46.7019 74.5746 46.8465 71.9769C46.9563 69.9971 47.5319 65.9395 47.9173 63.1475C47.9309 63.048 47.9439 62.9525 47.9569 62.8615C48.0318 62.3183 48.0885 61.9187 48.1156 61.7271C48.1274 61.6446 48.1339 61.6005 48.1339 61.6005C48.2378 61.5548 48.3464 61.5124 48.4592 61.4734C51.1656 60.5425 56.3842 61.5282 56.3842 61.5282C56.3842 61.5282 56.3872 61.5525 56.3931 61.5988C56.3996 61.6548 56.4108 61.743 56.425 61.8566C56.4551 62.103 56.4999 62.4692 56.5513 62.8948L56.5519 62.9039C56.5536 62.9169 56.5554 62.9299 56.5566 62.9429C56.739 64.457 56.8287 65.289 56.9722 66.9043C57.0034 67.2587 56.6865 75.4156 56.6865 76.4764Z",
    fill: "#248C9E"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9505 47.2604C53.9505 47.2604 58.3817 48.1613 58.7512 49.3403C59.1207 50.5193 59.8379 53.2888 60.8361 56.3007C61.4328 58.1025 64.4657 62.2064 64.4657 62.2064C64.4657 62.2064 62.7303 63.4312 62.7303 63.2661C62.7303 63.1011 58.6432 57.8793 58.5942 57.2423C58.5446 56.6059 57.3062 53.3493 57.3062 53.3493C57.3062 53.3493 56.7195 59.6099 56.7195 60.577C56.7195 61.544 56.9745 64.5152 56.9745 64.5152C56.9745 64.5152 55.1924 65.9322 52.0038 65.7733C52.0038 65.7733 47.4988 65.7914 47.5613 64.0947C47.6162 62.5998 48.0005 53.6432 47.9019 53.5963C47.8034 53.5488 46.0343 55.6705 46.2067 56.0791C46.379 56.4878 50.9578 57.9528 50.9578 57.9528C50.9578 57.9528 51.0918 58.4247 50.3805 59.4946C50.3805 59.4946 43.5416 57.5809 43.5168 57.1801C43.492 56.7794 46.3613 48.9933 47.2981 48.5858C48.6474 47.9991 52.221 47.2158 52.221 47.2158L53.9505 47.2604Z",
    fill: "#2AA3B8"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2598 88.0543C54.2598 88.0543 54.6009 88.0967 54.8441 88.1334C55.0867 88.1702 55.5678 87.8729 56.0513 87.9452L55.9025 88.5325C55.9025 88.5325 54.294 88.2437 54.2598 88.0543Z",
    fill: "#353A3D"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1073 47.3604C54.086 48.3964 51.601 49.4878 51.601 49.4878C51.601 49.4878 50.9971 47.5503 51.2061 47.4497C51.2887 47.4101 51.3147 47.3858 51.3247 47.2095C51.3342 47.0422 51.3229 46.8568 51.3129 46.7398C51.307 46.6663 51.3011 46.6189 51.3011 46.6189C51.3011 46.6189 51.6004 46.3165 51.9811 45.9559C52.6469 45.3257 53.5996 44.3931 53.6014 44.7142C53.6014 44.7311 53.6268 44.7396 53.6215 44.7633C53.4609 45.4862 54.1073 47.3604 54.1073 47.3604Z",
    fill: "#EEA886"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1764 45.6134V45.6139C53.1722 45.6196 53.0831 45.7473 52.9314 45.9299C52.6097 46.3176 52.0047 46.954 51.3247 47.2095C51.3341 47.0422 51.3229 46.8568 51.3129 46.7398C51.2432 46.7381 51.1736 46.7302 51.1045 46.7155C51.291 46.4035 51.5602 46.0768 51.5602 46.0768L51.9811 45.9559L53.1764 45.6134Z",
    fill: "#A77860"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5786 44.8538C53.3973 45.2313 53.2256 45.5049 53.1766 45.6134V45.614C53.1447 45.6846 53.0579 45.7993 52.9316 45.9299C52.5863 46.286 51.9441 46.7562 51.3131 46.7398C51.2434 46.7381 51.1738 46.7302 51.1047 46.7155C50.8503 46.6624 50.5493 46.5488 50.3834 46.2385C49.0759 43.7872 50.0227 41.7831 50.0227 41.7831C50.0227 41.7831 53.598 40.8149 54.157 41.8452C54.5496 42.5681 54.0047 43.9664 53.5786 44.8538Z",
    fill: "#EEA886"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0231 41.7831C50.0231 41.7831 49.6914 41.7656 49.6093 41.1625C49.5279 40.5674 50.3312 40.1571 50.3312 40.1571C50.3312 40.1571 50.9557 39.8326 51.6977 39.7337C52.229 39.6631 53.5311 39.5828 53.8369 39.9174C53.8369 39.9174 54.5789 39.7524 54.7813 40.932C55.1018 42.8039 53.6881 44.621 53.6881 44.621C53.6881 44.621 53.6999 43.3985 53.4184 43.2362C53.1368 43.0746 52.8936 43.4595 52.8936 43.4595L52.3175 43.5584C52.3175 43.5584 53.1339 42.0471 52.0843 41.9804C51.0348 41.9131 50.624 41.8883 50.0231 41.7831Z",
    fill: "#223247"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9092 42.9722C52.9641 42.4336 53.9812 42.2279 53.9133 42.7925C53.8448 43.3571 53.3443 43.8997 53.1129 43.8805C52.8809 43.8613 52.8673 43.3825 52.9092 42.9722Z",
    fill: "#EEA886"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2369 54.1089L51.5711 62.3195L46.0674 61.2959L47.5183 53.0452L53.2369 54.1089Z",
    fill: "#616161"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8243 54.5084L51.3451 61.8005L46.457 60.8917L47.7456 53.564L52.8243 54.5084Z",
    fill: "#E0CEC7"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2743 54.4084L51.3782 53.8964L49.4019 53.529L49.2207 54.0264L51.2743 54.4084Z",
    fill: "#616161"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1592 57.8866C52.1592 57.8866 52.5795 57.8753 52.7087 57.8572C52.8374 57.8396 52.7524 58.1019 52.6031 58.1516C52.4531 58.2008 52.1592 57.8866 52.1592 57.8866Z",
    fill: "#C98462"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4043 59.8111C52.4043 59.8111 52.2208 59.8535 52.131 59.8349C52.131 59.8349 51.9699 59.7885 51.8536 59.7619C51.817 59.754 51.7845 59.7478 51.7633 59.7456C51.6736 59.7371 51.4752 59.7439 51.2669 59.6659C51.0585 59.5879 50.3525 59.2408 50.3525 59.2408L50.5544 58.6123L50.7067 58.1138C50.7067 58.1138 51.9002 57.8098 52.1033 57.8612C52.1228 57.8663 52.1423 57.8719 52.16 57.8787C52.3276 57.9381 52.4256 58.0494 52.51 58.0901C52.5407 58.1054 52.8364 58.2749 52.8518 58.3727C52.873 58.5083 52.8311 58.6106 52.7579 58.6734C52.7579 58.6734 52.788 58.9402 52.6847 59.0911C52.6847 59.0911 52.7207 59.3364 52.536 59.4895C52.536 59.4895 52.5436 59.7422 52.4043 59.8111Z",
    fill: "#EEA886"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9582 57.9527C50.9582 57.9527 50.7362 59.1006 50.0987 59.8394C50.0987 59.8394 45.3588 57.994 44.7603 57.7691C44.1623 57.5435 46.9337 50.4916 46.9337 50.4916L48.9731 51.1563L47.8775 53.1401C47.8775 53.1401 47.3351 54.2513 46.2071 56.0791C46.2071 56.0791 46.9012 56.7104 50.9582 57.9527Z",
    fill: "#2AA3B8"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7872 51.7718C53.7872 51.7718 53.6621 53.9688 54.809 53.9688C55.9559 53.9688 55.852 51.9917 55.8727 51.7718H53.7872Z",
    fill: "#258EA1"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9912 51.7717H55.7042V51.4383L53.9912 51.7717Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9657 56.1276C89.9657 56.1276 89.5759 55.3204 89.5127 55.199C89.4495 55.0774 89.0769 54.8847 88.634 54.7779C88.204 54.6739 87.6196 54.4659 87.5521 54.506C87.4853 54.5462 87.4078 54.5512 87.3281 54.7293C87.2484 54.9073 87.2829 55.0994 87.2829 55.0994C87.2829 55.0994 87.0776 55.2741 87.1386 55.5081C87.1386 55.5081 86.9534 55.6811 87.0689 55.9359C87.0689 55.9359 86.8923 56.1094 86.9928 56.2875C86.9928 56.2875 87.3382 56.4751 87.4444 56.5797C87.5514 56.6848 88.2973 57.0279 89.0655 57.2517C89.0655 57.2517 89.8659 57.2274 89.9657 56.1276Z",
    fill: "#8E4F3A"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0654 57.2519C89.0654 57.2519 90.0187 57.4108 90.3416 57.2327C90.6644 57.0547 90.2881 56.125 90.2881 56.125L89.6851 55.7756L89.0654 57.2519Z",
    fill: "#8E4F3A"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7123 55.7366C88.7123 55.7366 88.7266 56.1831 88.7963 56.3063C88.8674 56.4295 87.918 56.6217 87.918 56.6217C87.918 56.6217 88.1455 55.7677 88.7123 55.7366Z",
    fill: "#5E3527"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6723 54.5444C87.6723 54.5444 88.7127 55.0288 88.653 55.1989C88.5918 55.369 88.4617 55.3962 88.4617 55.3962L88.7952 55.7817C88.7952 55.7817 88.8663 56.1563 88.4197 56.1208C88.4197 56.1208 88.5236 56.4638 88.0961 56.3802C88.0961 56.3802 88.0592 56.6362 87.8543 56.6312C87.6495 56.6255 86.9931 56.2875 86.9931 56.2875C86.9931 56.2875 86.868 56.149 87.05 55.9286C87.05 55.9286 86.9263 55.6929 87.1218 55.503C87.1218 55.503 87.0621 55.1933 87.2762 54.9898C87.2762 54.9898 87.2541 54.6467 87.5613 54.5009C87.5613 54.5009 87.6282 54.5241 87.6723 54.5444Z",
    fill: "#7A4432"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4817 55.1803C89.4817 55.1803 88.6879 55.1967 88.258 55.3877C88.1612 55.4307 88.0753 55.4895 88.0803 55.5923C88.086 55.6952 88.2479 55.8179 88.5926 55.828C88.9365 55.8376 89.3771 56.001 89.3771 56.001C89.3771 56.001 89.7339 55.9122 89.4817 55.1803Z",
    fill: "#8E4F3A"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M87.282 54.9924C87.282 54.9924 88.4631 55.3796 88.5441 55.4734C88.6251 55.5678 88.7772 55.1524 88.7026 55.0767C88.6272 55.0009 87.7027 54.5285 87.6011 54.5025C87.4988 54.4764 87.157 54.7071 87.282 54.9924Z",
    fill: "#8E4F3A"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8229 54.5497C87.8229 54.5497 85.9728 54.1868 85.935 54.4027C85.8973 54.6186 86.0768 54.6548 87.5928 55.0787C89.0674 55.4902 87.8229 54.5497 87.8229 54.5497Z",
    fill: "#8E4F3A"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M100.539 90.8887C100.539 90.8887 99.949 91.7336 99.122 91.9162C98.2942 92.0988 97.48 92.3887 97.4736 92.8889C97.4673 93.3885 99.8654 93.687 100.812 93.1829C102.225 92.4306 102.368 92.6578 102.525 92.2819C102.681 91.9055 102.337 90.9006 102.346 90.7808C102.36 90.6332 100.539 90.8887 100.539 90.8887Z",
    fill: "#353A3D"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M100.63 90.4723C100.63 90.4723 100.523 90.8804 100.539 90.8888C100.555 90.8979 102.403 91.1087 102.346 90.7809C102.302 90.5153 102.237 90.227 102.237 90.227L100.63 90.4723Z",
    fill: "#81807E"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M106.758 90.8329C106.758 90.8329 106.337 91.6411 105.618 91.9164C104.85 92.2108 104.234 92.5488 104.248 93.036C104.262 93.5227 106.126 94.0161 107.482 93.0818C108.339 92.4912 108.611 92.4884 108.748 92.1165C108.885 91.7445 108.509 90.7781 108.515 90.6611C108.521 90.5169 106.758 90.8329 106.758 90.8329Z",
    fill: "#353A3D"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M106.736 90.4134C106.736 90.4134 106.742 90.8249 106.758 90.8329C106.774 90.8407 108.56 90.9815 108.514 90.661C108.479 90.4067 108.341 90.0992 108.341 90.0992L106.736 90.4134Z",
    fill: "#81807E"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M100.187 65.7277C100.187 65.7277 98.5282 72.7366 98.1492 74.8714C97.8264 76.6884 97.5693 78.5801 97.7239 79.8919C97.9155 81.5163 100.316 89.9326 100.216 90.4084C100.115 90.8849 103.078 90.5956 103.078 90.5956C103.078 90.5956 100.902 81.0964 101.267 79.3493C101.537 78.055 103.904 69.4579 104.267 69.8993C104.629 70.3402 105.08 78.0127 105.348 79.2861C105.617 80.5599 106.441 90.6238 106.441 90.6238C106.441 90.6238 108.285 90.8844 108.778 90.4847C108.778 90.4847 109.002 81.8916 108.831 79.5042C108.766 78.5943 109.945 68.5926 108.432 64.5667C107.634 62.4388 100.187 65.7277 100.187 65.7277Z",
    fill: "#2D3133"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3516 57.5971C89.3516 57.5971 95.1 58.8174 96.244 58.5478C96.773 58.4234 97.4691 57.7243 98.1309 56.9025C98.3497 56.6323 98.5629 56.3481 98.7666 56.0672L98.7674 56.066C99.5796 54.943 100.216 53.8669 100.216 53.8669C100.216 53.8669 102.616 51.1737 100.69 49.9726C100.69 49.9726 99.9909 49.7223 99.3497 50.3807C98.7069 51.0397 97.9527 52.4177 97.7849 52.7692C97.6162 53.1202 95.2591 56.3763 95.1366 56.4498C95.0141 56.5233 93.9839 56.2638 93.1581 56.1977C91.8113 56.0903 89.7931 55.5879 89.7931 55.5879L89.3516 57.5971Z",
    fill: "#DBDFF0"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M102.491 49.3721C102.491 49.3721 100.02 49.8616 99.7268 50.1102C99.4082 50.3747 98.8466 52.9662 98.8139 53.6879C98.7803 54.4097 99.1115 57.425 99.4292 58.548C99.7486 59.671 99.6899 65.2015 99.4887 66.7574C99.4887 66.7574 104.464 68.1105 109.355 67.5007C109.355 67.5007 108.535 61.6826 108.731 60.1436C108.982 58.1727 109.586 53.6314 109.586 53.6314C109.586 53.6314 109.152 50.4674 108.716 50.1147C108.281 49.7621 105.28 49.3721 105.28 49.3721H102.491Z",
    fill: "#BCC0CF"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M103.513 42.0562C103.513 42.0562 100.541 41.0031 100.726 44.7852C100.912 48.5674 101.609 48.9517 103.564 48.4235C105.52 47.8953 105.684 45.5082 105.938 44.36C106.192 43.2117 104.486 42.2213 103.513 42.0562Z",
    fill: "#8E4F3A"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M102.103 49.8842C102.103 49.8842 102.714 50.2719 105.033 49.2935C105.033 49.2935 104.968 47.7708 105.423 46.3488C105.878 44.9268 102.31 48.2449 102.31 48.2449C102.348 48.2702 102.355 48.4123 102.334 48.6106C102.316 48.7786 102.277 48.9869 102.22 49.198C102.089 49.6739 102.103 49.4693 102.103 49.8842Z",
    fill: "#8E4F3A"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M105.524 46.2361C105.524 46.2361 105.533 45.2258 105.094 45.1328C104.655 45.0398 104.598 44.7038 104.598 44.7038L104.345 44.7597C104.345 44.7597 104.391 44.5818 103.973 44.3471C103.555 44.1123 101.053 44.3186 100.738 43.9739C100.424 43.6292 100.88 41.5819 101.562 41.381C102.245 41.18 103.831 41.1985 105.28 41.5882C105.28 41.5882 106.381 41.8539 106.463 43.0939C106.518 43.8965 105.881 45.6883 105.524 46.2361Z",
    fill: "#2D3133"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M102.221 49.1978C104.524 48.8271 104.868 47.5725 104.874 47.5529C103.979 48.6588 102.335 48.6102 102.335 48.6102C102.317 48.7783 102.278 48.9866 102.221 49.1978Z",
    fill: "#633029"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M102.322 50.3807C102.322 50.3807 101.902 50.9735 101.649 52.4945C101.395 54.016 101.438 56.6362 101.438 56.6362L102.021 56.7041C102.021 56.7041 102.905 51.3596 102.753 50.4287L102.322 50.3807Z",
    fill: "#434343"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M104.598 44.7038C104.729 44.3706 105.47 44.4125 105.394 44.941C105.318 45.4693 104.706 46.2831 104.46 46.1304C104.213 45.9778 104.417 45.1635 104.598 44.7038Z",
    fill: "#8E4F3A"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6954 50.1072C99.6954 50.1072 98.2912 51.8859 98.8116 56.5396C99.7517 64.9486 97.29 78.4471 97.29 78.4471L99.8294 79.2079C99.8294 79.2079 102.256 61.952 101.638 55.6896C101.357 52.8354 100.52 51.8859 101.84 49.5081C101.84 49.5081 100.555 49.5703 99.6954 50.1072Z",
    fill: "#DBDFF0"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M105.963 49.4692C105.963 49.4692 101.944 53.3566 101.629 56.3035C101.314 59.2504 100.802 79.208 100.802 79.208L110.37 78.6745C110.37 78.6745 109.492 68.1393 109.277 66.8212C109.062 65.5038 108.617 57.9364 109.586 54.4248C110.106 52.5388 109.487 50.1458 108.299 49.8841C107.11 49.6229 105.963 49.4692 105.963 49.4692Z",
    fill: "#DBDFF0"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M107.322 49.9729C107.322 49.9729 105.773 50.381 106.625 53.1012C107.292 55.232 107.382 55.6898 107.382 55.6898L110.954 54.8353C110.954 54.8353 109.907 50.1549 108.197 49.9034C108.197 49.9034 107.653 49.8293 107.322 49.9729Z",
    fill: "#DBDFF0"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6123 64.3707L102.613 71.3079L107.263 67.005L100.444 59.9L95.6123 64.3707Z",
    fill: "#616161"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2744 64.5086L102.492 70.6697L106.622 66.8484L100.565 60.538L96.2744 64.5086Z",
    fill: "#E0CEC7"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7074 63.4785L97.2705 63.0461L98.9406 61.5014L99.4419 61.8733L97.7074 63.4785Z",
    fill: "#616161"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M105.033 48.8725C105.033 48.8725 103.82 49.5728 102.621 49.7305L103.259 50.7054L105.281 49.3722L105.033 48.8725Z",
    fill: "#A7AAB8"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M102.22 49.1979C102.22 49.1979 102.348 49.5992 102.621 49.7303L102.021 50.5306L102.044 49.4692L102.22 49.1979Z",
    fill: "#A7AAB8"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M102.622 49.7302L102.146 50.3637C102.146 50.3637 102.447 50.7277 103.093 50.4519L102.622 49.7302Z",
    fill: "#434343"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1314 56.9019V56.9025C98.3498 56.6322 98.5629 56.348 98.7666 56.067L98.7674 56.0659C98.7674 56.0659 98.691 54.0154 98.7582 53.4265C98.7582 53.4265 98.058 55.6347 98.1314 56.9019Z",
    fill: "#A7AAB8"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M107.994 55.5432C107.994 55.5432 108.461 58.4511 108.428 58.6376C108.396 58.8236 110.541 58.0532 107.994 55.5432Z",
    fill: "#A7AAB8"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5654 56.1514H100.693V54.5027H99.5654V56.1514Z",
    fill: "#C6CAD9"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M104.579 62.4081C104.579 62.4081 104.475 62.6036 104.304 62.6698C104.008 62.7834 103.534 62.6031 103.35 63.0089C103.167 63.4147 104.349 64.3682 104.645 64.4179C104.942 64.4676 105.361 64.0031 105.634 63.1078C105.908 62.2125 104.579 62.4081 104.579 62.4081Z",
    fill: "#8E4F3A"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M103.433 62.8811C103.433 62.8811 102.924 63.3169 102.421 63.8708C101.98 64.3563 101.555 65.0091 101.631 65.1323C101.8 65.4058 102.21 64.7949 102.682 64.3421C103.117 63.9262 103.045 63.9991 103.045 63.9991C103.045 63.9991 103.045 63.9544 102.666 64.5004C102.258 65.0871 101.903 65.7308 102 65.8738C102.047 65.9433 102.236 66.1135 102.328 65.8331C102.246 65.9642 102.232 65.932 102.286 65.9716C102.568 66.1779 103.309 65.4104 103.603 65.1052C103.379 65.3408 103.241 65.5381 103.495 65.5579C103.786 65.5805 104.782 64.4478 105.18 64.0765C105.614 63.6718 103.433 62.8811 103.433 62.8811Z",
    fill: "#8E4F3A"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M107.137 50.1549C106.813 50.2752 106.69 50.8257 106.823 52.4218C106.956 54.018 107.543 54.7521 107.762 55.1212C107.981 55.4903 109.185 57.7663 108.968 58.0653C108.752 58.3648 106.708 60.2961 106.589 60.4532C106.471 60.6103 104.189 62.5885 104.189 62.5885L105.351 64.1433C105.351 64.1433 110.279 60.4572 110.663 60.0892C111.049 59.7213 112.198 58.9481 111.772 57.6629C111.341 56.3561 110.563 53.2973 110.426 53.0582C110.288 52.8192 109.279 49.3608 107.137 50.1549Z",
    fill: "#DBDFF0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_51_7593",
    x1: 36.958,
    y1: 10.3921,
    x2: 57.0898,
    y2: 10.3921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_51_7593",
    x1: 38.1631,
    y1: -10.7691,
    x2: 48.0824,
    y2: -10.7691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_51_7593",
    x1: 91.502,
    y1: 12.5399,
    x2: 97.3064,
    y2: 32.5077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40D5E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_51_7593",
    x1: 121.936,
    y1: 15.8893,
    x2: 136.104,
    y2: -8.67301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#602F80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5770FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_51_7593",
    x1: -239.149,
    y1: 290.954,
    x2: -233.276,
    y2: 286.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#602F80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5770FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_51_7593",
    x1: 247.639,
    y1: 18.2874,
    x2: 58.2367,
    y2: 18.2874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_51_7593",
    x1: 8.06995,
    y1: 62.9135,
    x2: 8.06995,
    y2: 49.9308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_51_7593",
    x1: 11.4117,
    y1: 62.9135,
    x2: 11.4117,
    y2: 49.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_51_7593",
    x1: 14.754,
    y1: 62.9135,
    x2: 14.754,
    y2: 49.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_51_7593",
    x1: 18.0963,
    y1: 62.9135,
    x2: 18.0963,
    y2: 49.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_51_7593",
    x1: 82.0723,
    y1: 105.991,
    x2: 83.973,
    y2: -6.75913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40D5E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_51_7593",
    x1: 82.1679,
    y1: 16.6528,
    x2: 96.6748,
    y2: 16.6528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40D5E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_51_7593",
    x1: 81.1176,
    y1: 24.8025,
    x2: 94.3061,
    y2: 24.8025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40D5E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_51_7593",
    x1: 79.533,
    y1: 22.3935,
    x2: 90.7769,
    y2: 22.3935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40D5E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_51_7593",
    x1: 55.5356,
    y1: 39.8275,
    x2: 55.5356,
    y2: 26.3762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DB3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_51_7593",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(152.988 23.1923) rotate(180) scale(67.8187 64.9369)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90C2E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.160246,
    stopColor: "#90C2E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58057,
    stopColor: "#47AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6783F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_51_7593",
    x1: -225.831,
    y1: 279.319,
    x2: -220.328,
    y2: 274.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3EFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_51_7593",
    x1: 185.06,
    y1: 38.1915,
    x2: 38.8061,
    y2: 38.1915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFCF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_51_7593",
    x1: 82.072,
    y1: 105.991,
    x2: 83.9727,
    y2: -6.75905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1FCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F5FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_51_7593",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(111.972 41.9789) rotate(180) scale(52.3687 50.1434)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.160246,
    stopColor: "#F7FBFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58057,
    stopColor: "#F1F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_51_7593",
    x1: 14.7305,
    y1: 75.0651,
    x2: 14.2578,
    y2: 55.2346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_51_7593",
    x1: 12.214,
    y1: 75.125,
    x2: 11.7413,
    y2: 55.2946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_51_7593",
    x1: 74.3128,
    y1: -4.81724,
    x2: 69.7979,
    y2: 12.8216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_51_7593",
    x1: 74.5631,
    y1: -5.41958,
    x2: 70.0262,
    y2: 12.3049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_51_7593",
    x1: 55.0701,
    y1: 19.8485,
    x2: 56.0946,
    y2: 36.2277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40D5E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5577FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_51_7593",
    x1: 55.0698,
    y1: 19.8485,
    x2: 56.0943,
    y2: 36.2275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40D5E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5577FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeekReport);
export default __webpack_public_path__ + "static/media/week-report.823361f2fab77e6b6c9f601fe0c3b00b.svg";
export { ForwardRef as ReactComponent };